import React from "react";
import styled from "styled-components";
import { Button } from "../atoms";
import { OAuthProviderIcon } from "../atoms/OAuthProviderIcon";
import { typographyMixin } from "../../design-system/tokens/typography";
import { authColors } from "../../styles/authTokens";

const StyledOAuthButton = styled(Button)`
  && {
    ${typographyMixin("body", 3)}
    padding: 8px 16px;
    min-height: 36px;
    border-radius: 8px;
    box-shadow: ${authColors.inputShadow};
    gap: 16px;
  }
`;

export type OAuthProvider = "google" | "microsoft" | "sso";

interface OAuthButtonProps {
  provider: OAuthProvider;
  onClick?: () => void;
  disabled?: boolean;
}

const providerConfig: Record<OAuthProvider, { label: string; icon?: React.ReactNode }> = {
  google:    { label: "Continue with Google",            icon: <OAuthProviderIcon provider="google" /> },
  microsoft: { label: "Continue with Microsoft",         icon: <OAuthProviderIcon provider="microsoft" /> },
  sso:       { label: "Continue with Organization SSO" },
};

export const OAuthButton: React.FC<OAuthButtonProps> = ({ provider, onClick, disabled }) => {
  const config = providerConfig[provider];
  return (
    <StyledOAuthButton
      variant="secondary"
      size="sm"
      fullWidth
      onClick={onClick}
      disabled={disabled}
      iconBefore={config.icon}
    >
      {config.label}
    </StyledOAuthButton>
  );
};
